import PersonalizerApi from "@/services/personalizer_api";   
import {
  GET_CATALOG_ITEMS,
  FETCH_ITEMS_RECOMMEND,
  FETCH_ITEMS_PURCHASED_TOGETHER,
  FETCH_USERS_RECOMMEND,
  FETCH_TRENDING_ITEMS,
  IMAGE_ITEMS_RECOMMEND,
  USERS_SEARCH_RECOMMEND,
  QUESTIONNAIRES_LIST,
  QUESTIONNAIRE_DETAILS,
  QUESTIONNAIRE_RECOMMEND,
  ITEMS_SEARCH,
  IMAGES_SEARCH,
  USERS_KEYWORDS,
  CATEGORIES_KEYWORDS,
} from "@/store/_actiontypes";

const state = {
    
};

const actions = {
    [GET_CATALOG_ITEMS]({ commit }, { project_id, start, size }) {
        if(!start) start = 0;
        if(!size) size = 100; //total hits currently unavailable
        return new Promise((resolve, reject) => {
            PersonalizerApi.post(`items/scroll`,{start, size}, {
                headers: {
                    "project-id":  project_id
                }
            }).then((response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            }
        )});
    },
    [FETCH_ITEMS_RECOMMEND]({ commit }, { project_id, user_id, member_id, item_id, date_range_filters,  details=true }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.post(`items/recommend`, {user_id, member_id, item_id, date_range_filters, details}, { headers: {
                "project-id":  project_id
            }}).then(
            (response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            }
        )});
    },
    [FETCH_ITEMS_PURCHASED_TOGETHER]({ commit }, { project_id, user_id, member_id, item_id, date_range_filters, details=true }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.post(`items/purchased/together`, {user_id, member_id, item_id, date_range_filters, details}, { headers: {
                "project-id":  project_id
            }}).then((response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            }
        )});
    },
    [FETCH_USERS_RECOMMEND]({ commit }, { project_id, user_id, member_id, interval, top_n_item, date_range_filters, start, size, flags,  details=true }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.post(`users/recommend`, {user_id, member_id, interval, top_n_item, date_range_filters, start, size, flags, details}, { headers: {
                "project-id":  project_id
            } }).then((response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            }
        )});
    },
    [FETCH_TRENDING_ITEMS]({ commit }, { project_id, interval, top_n_item, details=true }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.post(`items/trending`, {interval, top_n_item, details}, { headers: {
                "project-id":  project_id
            } }).then((response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            }
        )});
    },
    [IMAGE_ITEMS_RECOMMEND]({ commit }, { project_id, user_id, member_id, item_id, item_details,  details=true  }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.post(`items/image/recommend`, {user_id, member_id, item_id, item_details, details}, { headers: {
                "project-id":  project_id
            } }).then((response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            }
        )});
    },
    [USERS_SEARCH_RECOMMEND]({ commit }, { project_id, user_id, member_id, type, search_size, language, top_k, date_range_filters, start, size, flags, is_keyword_enabled,  details=true  }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.post(`users/search/recommend`, {user_id, member_id, type, search_size, language, top_k, date_range_filters, start, size, flags, is_keyword_enabled, details}, { headers: {
                "project-id":  project_id
            } }).then((response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            }
        )});
    },
    [QUESTIONNAIRES_LIST]({ commit }, { project_id }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.get(`questionnaires/list`, { headers: {
                "project-id":  project_id
            } }).then((response) => {
                  resolve(response);
              },
              (error) => {
                  reject(error);
              }
          );
      });
    },
    [QUESTIONNAIRE_DETAILS]({ commit }, { project_id, questionnaire_id }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.get(`questionnaires/${questionnaire_id}`, { headers: {
                "project-id":  project_id
            } }).then((response) => {
                  resolve(response);
              },
              (error) => {
                  reject(error);
              }
          );
      });
    },
    [QUESTIONNAIRE_RECOMMEND]({ commit }, { project_id, user_id, member_id, questionnaire_id, result_includes,recommend_count, top_k, is_keyword_enabled, values  }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.post(`questionnaire/recommend`,{user_id, member_id, questionnaire_id, result_includes, recommend_count, top_k, is_keyword_enabled, values}, { headers: {
                "project-id":  project_id
            } }).then((response) => {
                  resolve(response);
              },
              (error) => {
                  reject(error);
              }
          );
      });
    },
    [ITEMS_SEARCH]({ commit }, { project_id, user_id, member_id, message, type, price_lower, price_upper, details=true, categories , flags=null, sort=null, dynamic_filtering=null, start, size, date_range_filters, language }) {
        const payload = {
            user_id, member_id, message, type, price_lower, price_upper, details, categories, start, size, date_range_filters, language
        }
        if(flags){
            payload.flags = flags
        }
        if(sort){
            payload.sort = sort
        }
        if(dynamic_filtering){
            payload.dynamic_filtering = dynamic_filtering
        }
        return new Promise((resolve, reject) => {
            PersonalizerApi.post(`items/search`,{...payload}, { headers: {
                "project-id":  project_id
            } }).then((response) => {
                  resolve(response);
              },
              (error) => {
                  reject(error);
              }
          );
      });
    },
    [IMAGES_SEARCH]({ commit }, { project_id, user_id, member_id, image, start, size }) {
        const formData = new FormData()
        formData.append("user_id", user_id)
        formData.append("member_id", member_id)
        formData.append("image", image)
        formData.append("details", true)

        if(start) formData.append("start", start)
        if(size) formData.append("size", size)
            
        return new Promise((resolve, reject) => {
            PersonalizerApi.post(`images/search`,formData, { headers: {
                "project-id":  project_id,
                'Content-Type': 'multipart/form-data' 
            } }).then((response) => {
                  resolve(response);
              },
              (error) => {
                  reject(error);
              }
          );
      });
    },
    [USERS_KEYWORDS]({ commit }, { project_id, user_id, member_id }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.get(`users/keywords?user_id=${user_id}&member_id=${member_id}`, { headers: {
                "project-id":  project_id,
            } }).then((response) => {
                  resolve(response);
              },
              (error) => {
                  reject(error);
              }
          );
      });
    },
    [CATEGORIES_KEYWORDS]({ commit }, { project_id }) {
        return new Promise((resolve, reject) => {
            PersonalizerApi.get(`categories/keywords`, { headers: {
                "project-id":  project_id,
            } }).then((response) => {
                  resolve(response);
              },
              (error) => {
                  reject(error);
              }
          );
      });
    },
};

const mutations = {
 
};

export const ai_response = {
  namespaced: true,
  state,
  actions,
  mutations,
};
